/* eslint-disable no-underscore-dangle -- some of these are LDAP specific props which we can't really change. */
import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';

import { window } from '../../../../../../globals';
import { ErrorAlert } from '../../../../../generic';
import Loader from '../../../../../generic/Loader';
import useAuthenticationSettingsContext from '../../hooks/useAuthenticationSettingsContext';

type Props = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  connectionTest: { user: Record<string, string> & { _groups: Array<Record<string, string>> } };
  errors: null | Error[];
  isLoading: boolean;
};

const LDAPTestResults: VoidFunctionComponent<Props> = ({ connectionTest, errors, isLoading }) => {
  const { settings } = useAuthenticationSettingsContext();
  const ldapConfig = settings.ldap;
  const connectedUser = connectionTest?.user;

  if (isLoading) {
    return <Loader />;
  }

  if (errors) {
    return <ErrorAlert status={{ errors }} />;
  }

  if (connectedUser) {
    return (
      <ul className="ldap-test-results">
        {ldapConfig?.userNameAttr && (
          <li>
            <strong>Name:</strong> {connectedUser[ldapConfig.userNameAttr]}
          </li>
        )}
        {ldapConfig?.userEmailAttr && (
          <li>
            <strong>Email:</strong> {connectedUser[ldapConfig.userEmailAttr]}
          </li>
        )}
        {window.on_prem && ldapConfig?.uidAttr && (
          <li>
            <strong>Username:</strong> {connectedUser[ldapConfig.uidAttr]}
          </li>
        )}
        {ldapConfig?.useGroups && (
          <li>
            <strong>Groups:</strong>
            <ul>
              {_.isEmpty(connectedUser._groups) ? (
                <li>No Groups Found</li>
              ) : (
                connectedUser._groups.map(
                  (group: Record<string, string>) =>
                    ldapConfig?.groupNameAttr && <li key={group.dn}>{group[ldapConfig.groupNameAttr]}</li>,
                )
              )}
            </ul>
          </li>
        )}
      </ul>
    );
  }

  return <p>{`Click the 'Test Login' button to see results.`}</p>;
};

export default LDAPTestResults;
